export default {
  Get: {
    LIST_OF_PROPERTY_DOCUMENTS: "getListOfPropertyDocuments",
    GET_PROPERTY_DOCUMENT: "getPropertyDocument",
    GET_PROPERTY_DOCUMNET_LEVEL: "getPropertyDocumentLevel",
    CHECK_PROPERTY_DOCUMNET_HAS_CHILDS: "checkPropertyDocumentHasChilds",
    CHECK_PROPERTY_DOCUMNET_CHILDS: "listOfChildPropertyDocumentsByGroupId",
    GET_PROPERTY_CHILDS_DOCUMENT: "listOfChildPropertyDocumentsByGroupId"
  },
  Set: {
    LIST_OF_PROPERTY_DOCUMENTS: "setListOfPropertyDocuments",
    INSERT_PROPERTY_DOCUMENTS: "insertPropertyDocuments",
    UPDATE_PROPERTY_DOCUMENT: "updatePropertyDocument",
    DELETE_PROPERTY_DOCUMENT: "deletePropertyDocument",
    INSERT_GROUP_PROPERTY_DOCUMENT: "insertGroupPropertyDocuments",
    MOVE_GROUP_PROPERTY_DOCUMENT: "moveGroupPropertyDocument"
  }
};
